import moment from "moment";
import React from "react";
import { useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Col, Row } from "reactstrap";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import * as S from "src/constants/StringConstants";

const CATEGORY_CLOSED = "CLOSED";
const CATEGORY_PAID = "PAID";

interface PolicyInformationFormProps {
  carrierOptions: { key: string; value: any }[];
  statusOptions: { key: string; value: any }[];
  productOptions: { key: string; value: any }[];
  onStatusHistoryClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const PolicyInformationForm = ({
  carrierOptions,
  statusOptions,
  productOptions,
  onStatusHistoryClick,
}: PolicyInformationFormProps) => {
  const carrierId = useForm().getFieldState("carrierId")?.value;
  const form = useForm();

  return (
    <>
      <Row>
        <Col sm="12" className="app-form-header">
          <h4 className="form-title">{S.APP_POLICY_INFORMATION_TITLE}</h4>
        </Col>
      </Row>
      <Row>
        <Col sm="8">
          <TypeaheadField name="statusId" label={S.APP_FIELD_STATUS_LABEL} options={statusOptions} />
        </Col>
        <Col sm="2">
          <label className="form-dropdown__label">&nbsp;</label>
          <button className="button-v2 button-v2__secondary-mini" onClick={onStatusHistoryClick}>
            {S.APP_FIELD_STATUS_HISTORY_LABEL}
          </button>
        </Col>
      </Row>
      <Row>
        <Col sm="5" style={{ marginBottom: "12px" }}>
          <SimpleDatePickerField
            label={S.APP_FIELD_STATUS_DATE_LABEL}
            name="lastStatusChangedDate"
            isFormMode
            showClear
          />
          <OnChange name="statusId">
            {value => {
              if (value) {
                const now = moment().format("YYYY-MM-DD");
                const status = statusOptions.find(option => option.value === value) as any;
                form.change("lastStatusChangedDate", now);
                // also update paidOrClosedDate if the status is CLOSED or PAID
                if (status.category === CATEGORY_CLOSED || status.category === CATEGORY_PAID) {
                  form.change("paidOrClosedDate", now);
                }
              }
            }}
          </OnChange>
        </Col>
      </Row>
      <Row style={{ marginTop: "12px" }}>
        <Col sm="10" style={{ marginTop: "12px" }}>
          <TextField name="policyNumber" label={S.APP_FIELD_POLICY_LABEL} />
        </Col>
      </Row>
      <Row style={{ display: "flex", alignItems: "baseline" }}>
        <Col sm="5">
          <SimpleDatePickerField label={S.APP_FIELD_EFFECTIVE_DATE_LABEL} name="policyDate" isFormMode showClear />
        </Col>
        <Col sm="5">
          <SimpleDatePickerField
            label={S.APP_FIELD_PAID_CLOSED_DATE_LABEL}
            name="paidOrClosedDate"
            isFormMode
            showClear
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "12px" }}>
        <Col sm="10" style={{ marginTop: "30px" }}>
          <TypeaheadField name="carrierId" label={S.APP_FIELD_CARRIER_LABEL} options={carrierOptions} />
        </Col>
      </Row>
      <Row>
        <Col sm="10">
          <TypeaheadField
            name="productId"
            label={S.APP_FIELD_PRODUCT_LABEL}
            options={productOptions.filter((product: any) => product.carrierID === carrierId)}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="10">
          <TextField name="selectProductType" label={S.APP_FIELD_TYPE_LABEL} disabled />
        </Col>
      </Row>
    </>
  );
};

export default PolicyInformationForm;
